module.exports = __webpack_public_path__ + "static/media/Rambaudi.8dfcdc81.mp4";